import ImageWithSkeleton from './ComponentsPage/ImageWithSkeleton';
import { useNavigate } from 'react-router-dom';

const KinLearnspace = () => {
  const navigate = useNavigate();

  const learningCards = [
    {
      title: 'Creative Expression',
      image: '/kin/assest/about/learnspace/learn-1.webp',
    },
    {
      title: 'Curiosity-Driven',
      image: '/kin/assest/about/learnspace/learn-2.webp',
    },
    {
      title: 'Supportive Environment',
      image: '/kin/assest/about/learnspace/learn-3.webp',
    },
  ];

  return (
    <section id="kinlearnspace" aria-labelledby="kinlearnspace-title" className="relative">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <div className="rounded-3xl bg-white p-6 sm:p-8 md:p-12 lg:p-16">
          <div className="mx-auto max-w-4xl text-center space-y-5 sm:space-y-6">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary-main sm:text-sm sm:tracking-widest">
              Learning Spaces
            </span>
            <h2 className="mt-1 text-2xl font-bold tracking-tight text-pretty text-kin-textdark sm:mt-2">
              Engaging Minds, Joyful Learning
            </h2>
            <p className="mx-auto max-w-3xl text-sm leading-relaxed text-kin-text sm:text-base">
              KiN Class brings the learning experience at KiN School Visit into structured and
              engaging class activities. Designed for different age groups, each class encourages
              creativity, curiosity, and joyful learning in a safe and supportive environment.
            </p>

            <div className="grid gap-5 pt-6 sm:grid-cols-2 sm:gap-6 sm:pt-8 lg:grid-cols-3 lg:gap-8">
              {learningCards.map((card) => (
                <div
                  key={card.title}
                  className="space-y-4 border-b-2 border-primary-main p-3 sm:p-4">
                  <ImageWithSkeleton
                    src={card.image}
                    alt={card.title}
                    aspect="aspect-[4/3]"
                    rounded="rounded-xl"
                    object="object-cover"
                    ring={false}
                    className="h-full w-full"
                  />
                  <p className="text-sm font-bold text-slate-900 sm:text-base">{card.title}</p>
                </div>
              ))}
            </div>

            <button
              type="button"
              onClick={() => navigate('/learn/our-class?page=1&limit=6')}
              className="mt-4 inline-flex w-full items-center justify-center rounded-2xl bg-primary-main px-6 py-3 text-sm font-bold text-white transition hover:opacity-90 active:scale-[0.98] sm:mt-6 sm:w-auto">
              Explore Our Classes
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KinLearnspace;
